import { useInstantSearch, useRefinementList } from 'react-instantsearch';

import { INSTANT_SEARCH_TOPIC_FILTER } from 'src/app/pages/search/shared/consts';

type Result = ModelHookResult<{
	nOfFilters: number;
	disabled: boolean;
}>;

export function useTopicsMobileButton(): Result {
	const { indexUiState } = useInstantSearch();
	const { canRefine } = useRefinementList({
		attribute: INSTANT_SEARCH_TOPIC_FILTER,
		limit: 30,
		operator: 'or',
	});

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	const nOfFilters = indexUiState.refinementList?.tags?.length || 0;

	const disabled = !canRefine;

	return {
		data: {
			nOfFilters,
			disabled,
		},
	};
}
